import {createWebHashHistory, createRouter} from 'vue-router';
import CalcRoot from "@/components/CalcRoot";
import ResultsContainer from "@/components/ResultsContainer";

const routes = [
    {
        path: "/",
        name: "Root",
        component: CalcRoot
    },
    {
        path: "/results",
        name: "Results",
        component: ResultsContainer,
    }
]

const router = createRouter({
    history: createWebHashHistory("/apps/mhcc"),
    routes
});

export default router;